import {
  Actions,
  type NotificationActionCreators,
  type NotificationOptions,
  NotificationType,
  type ToastContainerId,
} from './types'

export const notificationActionCreators = {
  setNotification: (payload: NotificationActionCreators) =>
    ({
      type: Actions.NOTIFICATION,
      payload,
    }) as const,

  setSocketNotification: (payload: NotificationActionCreators) =>
    ({
      type: Actions.SOCKET_NOTIFICATION,
      payload,
    }) as const,

  setCustomNotification: (payload: NotificationOptions) =>
    ({
      type: Actions.CUSTOM_NOTIFICATION,
      payload,
    }) as const,

  setClearNotification: (payload: {
    toastContainerId: ToastContainerId
    index?: number
  }) => ({ type: Actions.CLEAR_NOTIFICATION, payload }) as const,

  setClearAllNotification: () =>
    ({ type: Actions.CLEAR_ALL_NOTIFICATION }) as const,
}

// todo: refactor notifications

export const GeneralErrorNotification =
  notificationActionCreators.setNotification({
    type: NotificationType.SOMETHING_WENT_WRONG_ERROR,
  })

export const CopySuccessfulNotification =
  notificationActionCreators.setNotification({
    type: NotificationType.COPY_SUCCESS,
  })

export const CopyFailedNotification =
  notificationActionCreators.setNotification({
    type: NotificationType.COPY_FAILED,
  })

export const ErrorNotification = (message: string) =>
  notificationActionCreators.setCustomNotification({
    type: 'coral',
    text: message,
    toastContainerId: 'secondary',
  })

export const ContactSupportErrorNotification =
  notificationActionCreators.setCustomNotification({
    type: 'coral',
    text: 'Error: please contact support hello@octopus.do',
    toastContainerId: 'secondary',
  })

export const CancelSubscriptionSuccess =
  notificationActionCreators.setCustomNotification({
    type: 'topaz',
    text: 'Subscription canceled',
    toastContainerId: 'secondary',
  })

export const ApiKeyRevokedNotification =
  notificationActionCreators.setCustomNotification({
    type: 'topaz',
    text: 'API key revoked',
    toastContainerId: 'secondary',
  })

export const ChangesSavedNotification =
  notificationActionCreators.setCustomNotification({
    type: 'topaz',
    text: 'Changes saved',
    toastContainerId: 'secondary',
  })
